<template>
    <v-row class="slide ma-0 pa-0">
        <v-col
            cols="12"
            md="4"
            class="slide__info col-center secondary--text">
            <div class="slide__logo col-center">
                <v-img
                    max-height="200"
                    :src="project.logo"
                    contain />
            </div>
            <div
                ref="heading"
                class="slide__title text-h3 my-5 text-center">
                {{ scrambledTitle }}
            </div>
            <!-- Same delay as the title, so the slide's enter animation is over. Faster than the
                 resume cards so even the longest description is typed well before the next slide. -->
            <TypeReveal
                class="col-center"
                :delay="500"
                :type-delay="4">
                <div class="text-h6 font-weight-light text-center">
                    <TypedText :text="`Role : ${project.role}`" />
                </div>
                <div
                    v-if="project.stack"
                    class="font-weight-bold text-body-2 my-5 text-center">
                    <TypedText :text="`Stacks : ${project.stack}`" />
                </div>
                <div class="text-justify">
                    <TypedText :text="project.description" />
                </div>
                <a
                    :href="project.url"
                    class="secondary--text"
                    target="_blank"
                    rel="noopener">
                    <TypedText :text="project.url" />
                </a>
            </TypeReveal>
        </v-col>
        <v-col
            cols="12"
            md="7"
            class="col-center">
            <v-img
                contain
                width="100%"
                :src="project.image"
                :lazy-src="project.imageLazy"
                :alt="project.title">
                <template #placeholder>
                    <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center">
                        <v-progress-circular
                            indeterminate
                            color="secondary" />
                    </v-row>
                </template>
            </v-img>
        </v-col>
    </v-row>
</template>

<script>
import { ref } from 'vue';
import { useScrambleReveal } from '@/composables/useTextScramble';
import TypeReveal from '@/components/effects/TypeReveal.vue';
import TypedText from '@/components/effects/TypedText.vue';

/** One project of the carousel. The title scrambles in and the details type in when it appears. */
export default {
    name: 'ProjectSlide',
    components: { TypeReveal, TypedText },
    props: {
        project: { type: Object, required: true },
    },
    setup(props) {
        const heading = ref(null);
        // The delay lets the slide's enter animation finish first.
        const scrambledTitle = useScrambleReveal(heading, () => props.project.title, { startDelay: 500 });

        return { heading, scrambledTitle };
    },
};
</script>

<style scoped>
.slide {
    width: 100%;
    max-width: 1200px;
    justify-content: space-between;
}
/* Keeps its line while the title is still empty, so the details don't jump. */
.slide__title {
    min-height: 1lh;
}
.slide__logo {
    width: 350px;
    max-width: 75vw;
    height: 200px;
}
/* The logos are dark and monochrome: white on the twilight backdrop. */
[data-theme='twilight'] .slide__logo {
    filter: brightness(0) invert(1);
}
</style>
